module.exports = __webpack_public_path__ + "img/google.31cd1eb5.jpg";